var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{attrs:{"items":_vm.items,"headers":_vm.headers},scopedSlots:_vm._u([{key:"item.actions",fn:function(ref){
var item = ref.item;
return [_vm._t("actions",null,{"item":item})]}},{key:"item.dateFrom",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(_vm._f("dateFormat")(item.dateFrom)))]}},{key:"item.dateTo",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(_vm._f("dateFormat")(item.dateTo)))]}},{key:"item.timeFrom",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(_vm._f("timeFormat")(item.timeFrom)))]}},{key:"item.timeTo",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(_vm._f("timeFormat")(item.timeTo)))]}},{key:"item.attachment",fn:function(ref){
var item = ref.item;
return [_vm._t("attachment",null,{"item":item})]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }